export { default } from './DifficultyIcon';
